/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import Component from 'can/component/component';
import template from './course-statistics-table.stache';

const roundsMap = {
    'round-1': 0,
    'round-2': 1,
    'round-3': 2,
    'round-4': 3,
};

Component.extend({
    tag: 'course-statistics-table',
    template,
    viewModel: {
        roundInfo: {},
        define: {
            missedFairway: {
                type: 'object',
            },
            missedFairwayData: {
                get() {
                    const missedFairway = this.attr(
                        'missedFairway',
                    ).serialize();

                    return new Array(18).fill(null).map((__, index) => {
                        const firstVal = _.get(
                            missedFairway,
                            `rounds.0.${index}`,
                        );
                        const secondVal = _.get(
                            missedFairway,
                            `rounds.1.${index}`,
                        );
                        const thirdVal = _.get(
                            missedFairway,
                            `rounds.2.${index}`,
                        );
                        const fourthVal = _.get(
                            missedFairway,
                            `rounds.3.${index}`,
                        );
                        const totalVal = _.get(missedFairway, `total.${index}`);

                        return [
                            _.isNil(firstVal) ? '-' : firstVal.toFixed(2),
                            _.isNil(secondVal) ? '-' : secondVal.toFixed(2),
                            _.isNil(thirdVal) ? '-' : thirdVal.toFixed(2),
                            _.isNil(fourthVal) ? '-' : fourthVal.toFixed(2),
                            _.isNil(totalVal) ? '-' : totalVal.toFixed(2),
                        ];
                    });
                },
            },
        },
        getAverage(average) {
            return average && average.toFixed(3);
        },
        getRoundInfo() {
            const rounds = this.attr('roundsInfo.rounds');
            const activeFilterIndex = this.attr('activeFilter');

            if (activeFilterIndex === 'all-rounds') {
                this.attr('roundInfo', this.attr('roundsInfo.allRounds'));
                this.attr('allRounds', true);
            } else {
                this.attr('roundInfo', rounds[roundsMap[activeFilterIndex]]);
                this.attr('allRounds', false);
                this.attr('roundNum', activeFilterIndex);
            }
        },
    },
    events: {
        inserted() {
            this.viewModel.getRoundInfo();

            this.viewModel.bind('activeFilter', () => {
                this.viewModel.getRoundInfo();
            });
        },
    },
});
